<template>
    <div class="trigger-container" :style="styleDynamicElement(el)" :class="el.getAnimationClass(currentElementIndex)">
        <div class="diaporama-container" :style="el.getStyle()">
            <component v-for="(media, index) in el.Diaporama" :key="index" class="media-element" :is="media.objectType"
                :el="media" v-show="index === currentIndex">
            </component>
        </div>
    </div>
</template>

<script>
import DynamicImage from "./image.vue"
import ImageElement from "./image.vue"
import TextElement from "./text.vue"
import ColorElement from "./color.vue"
import VideoElement from "./video.vue"
import BasePreviewComponents from "./base/basePreviewComponents.vue";
export default {
    name: 'DiaporamaItem',
    extends: BasePreviewComponents,
    components: {
        DynamicImage,
        ImageElement,
        TextElement,
        ColorElement,
        VideoElement
    },
    data() {
        return {
            timer: undefined,
            currentIndex: 0,
        }
    },
    computed: {
    },
    mounted() {
        if (this.timer)
            clearTimeout(this.timer);
        this.setTimer();
    },
    beforeUnmount() {
        if (this.timer)
            clearTimeout(this.timer);
    },
    watch: {
        "el.Diaporama.length": {
            handler() {
                if (this.timer)
                    clearTimeout(this.timer);
                this.currentIndex = 0
                this.setTimer();
            },
        }
    },
    methods: {
        setTimer() {
            if (this.el.Diaporama.length == 0 || (this.el.Diaporama.length <= 1 && this.timer == undefined)) {
                return;
            }
            this.el.Diaporama[this.currentIndex].playAnimationDeep = true;
            this.timer = setTimeout(() => {
                this.currentIndex++
                if (this.currentIndex >= this.el.Diaporama.length) {
                    this.currentIndex = 0;
                    if (this.el.Repeat) {
                        this.setTimer();
                    }
                }
                else {
                    this.setTimer();
                }
            }, this.el.Diaporama[this.currentIndex].Duration * 1000);
        },
    }
}
</script>
